import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from "@angular/router";

@Component({
    selector: 'version',
    templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit  {

  public current_version: string = '';

  constructor(private router: Router) { }

  ngOnInit(): void {

    environment.debug_mode = true;

    this.SetCurrentVersion();

    this.router.navigate(['/home'])
  }


  private SetCurrentVersion(): void {

    this.current_version = environment.version;

  }

}
